export interface MConsultationTemplateQuickActionsAction {
  type: string;
  name: string;
  label?: string;
  drugCode?: string;
  vaccineCode?: string;
  conceptId?: string;
  messageBody?: string;
  if?: string;
  else?: string;
}

export interface MConsultationTemplateQuickActionsProps {
  actions: MConsultationTemplateQuickActionsAction[];
  patientId?: string;
  consultationTopicId?: string;
  // SNOMED code identifying the topic heading these actions' records attach to.
  heading?: string;
  label?: string;
}

export const mConsultationTemplateQuickActionsDefaults = {
  label: "Quick Actions",
} satisfies Partial<MConsultationTemplateQuickActionsProps>;
